import React from 'react'
import { truncateString } from 'components/utils'

interface ContractProps {
  contract?: string
  contractVehicle?: string
  reviewCanEdit: boolean
}

const has = (val: string | null | undefined): boolean => (val != null)

export function Contract ({ contract, contractVehicle, reviewCanEdit }: ContractProps): React.ReactElement {
  const tooltipContent = (): string => {
    const contentString: string[] = []

    if (has(contractVehicle)) {
      contentString.push(`<strong>${contractVehicle as string}</strong>`)
    }

    if (has(contractVehicle) && has(contract)) {
      contentString.push('<br />')
    }

    if (has(contract)) {
      contentString.push(contract as string)
    }

    return contentString.join('')
  }

  const truncationLength = (): number => {
    return reviewCanEdit ? 19 : 40
  }

  return (
    <span
      className='contract fndn-tooltip'
      data-tooltip
      data-allow-html
      title={tooltipContent()}
    >
      <i className='fa-solid fa-file-contract' />
      {(has(contractVehicle)) ? <strong>{contractVehicle} </strong> : null}
      {(has(contractVehicle) && has(contract)) ? '- ' : null}
      {has(contract) ? truncateString(contract as string, truncationLength()) : null}
    </span>
  )
}
